import React from 'react';
import './CourseDetail.css';
import { Icon } from '@iconify/react';

export const COURSE_DETAILS = {
  'Certified Frontend Development': {
    tagline: 'Professional course by WeIntern',

    price: 11099,
    originalPrice: 15599,

    about: `This course is designed by industry experts to give you real-world skills and hands-on experience. Spread across 10 Weeks, this beginner-friendly program blends live sessions, hands-on assignments, and mentor support so you can move from fundamentals to real, working projects.

Along the way you'll get practical experience with HTML, CSS, JavaScript and React, build a portfolio you can show employers, and finish with a certificate that validates what you've learned. You will also work on live client-style projects under mentor guidance so that you are fully job-ready by the end of the program.`,

    curriculum: [
      {
        week: 'Week 1-2',
        title: 'HTML, CSS & Responsive Design',
        topics: [
          'Semantic HTML5',
          'CSS Flexbox & Grid',
          'Responsive layouts',
          'CSS animations',
        ],
      },
      {
        week: 'Week 3-4',
        title: 'JavaScript & ES6+',
        topics: [
          'Core JS concepts',
          'DOM manipulation',
          'Async/Await',
          'Fetch API',
        ],
      },
      {
        week: 'Week 5-7',
        title: 'React.js Fundamentals',
        topics: [
          'Components & Props',
          'State management',
          'React Hooks',
          'React Router',
        ],
      },
      {
        week: 'Week 8-10',
        title: 'Real Projects & Deployment',
        topics: [
          'Live project delivery',
          'Cloud deployment',
          'Code review',
          'Portfolio building',
        ],
      },
    ],

    mentor: {
      name: 'Karan Malhotra',
      role: 'Full Stack Engineer · 5+ years experience',
      bio: 'Built and shipped 20+ production applications; mentors students through real client project delivery.',
      email: 'karan.malhotra@we-intern.in',
    },

    testimonials: [
      {
        name: 'Ishaan Gupta',
        batch: 'B.Tech CSE, 2025',
      },
      {
        name: 'Riya Desai',
        batch: 'BCA, 2024',
      },
      {
        name: 'Vikram Nair',
        batch: 'B.Tech IT, 2025',
      },
    ],
  },
};

const CourseDetailModal = ({ course, onClose, onEnroll }) => {
  const details = COURSE_DETAILS[course.title] || {
    tagline: 'Professional course by WeIntern',

    price: course.price || 11099,
    originalPrice: course.originalPrice || 15599,

    about: `This course is designed by industry experts to give you real-world skills and hands-on experience. Spread across the program duration, this beginner-friendly course blends live sessions, hands-on assignments, and mentor support so you can move from fundamentals to real, working projects.

Along the way you'll get practical experience with industry tools, build a portfolio you can show employers, and finish with a certificate that validates what you've learned.`,

    curriculum: [
      {
        week: 'Week 1-4',
        title: 'Fundamentals',
        topics: [
          'Basics',
          'Core Concepts',
        ],
      },
      {
        week: 'Week 5-8',
        title: 'Intermediate',
        topics: [
          'Advanced Topics',
          'Projects',
        ],
      },
      {
        week: 'Week 9-12',
        title: 'Advanced & Projects',
        topics: [
          'Real Projects',
          'Deployment',
        ],
      },
    ],

    mentor: {
      name: 'WeIntern Mentor',
      role: 'Industry Expert',
      bio: 'Experienced professional guiding students through real projects.',
      email: 'contact@we-intern.in',
    },

    testimonials: [
      {
        name: 'Student 1',
        batch: '2025',
      },
      {
        name: 'Student 2',
        batch: '2024',
      },
    ],
  };

  const originalPrice =
    details.originalPrice ||
    Math.round(details.price * 1.4);

  const offerPrice = details.price;

  const discount = Math.round(
    ((originalPrice - offerPrice) / originalPrice) * 100
  );

  /*
   * Generate and download PDF directly in browser.
   * No curriculum.html
   * No window.open()
   * No window.print()
   * No external PDF URL
   */

  const downloadCurriculum = () => {
    const escapePdfText = (text) => {
      return String(text)
        .replace(/\\/g, '\\\\')
        .replace(/\(/g, '\\(')
        .replace(/\)/g, '\\)');
    };

    const wrapText = (text, maxLength = 82) => {
      const words = String(text).split(' ');
      const result = [];
      let currentLine = '';

      words.forEach((word) => {
        if (
          `${currentLine} ${word}`.trim().length > maxLength
        ) {
          if (currentLine) {
            result.push(currentLine.trim());
          }

          currentLine = word;
        } else {
          currentLine = `${currentLine} ${word}`.trim();
        }
      });

      if (currentLine) {
        result.push(currentLine.trim());
      }

      return result;
    };

    const lines = [];

    lines.push(course.title);
    lines.push('Professional course by WeIntern');
    lines.push('');
    lines.push('COURSE CURRICULUM');
    lines.push('');

    details.curriculum.forEach((module) => {
      lines.push(`${module.week} - ${module.title}`);

      module.topics.forEach((topic) => {
        lines.push(`  - ${topic}`);
      });

      lines.push('');
    });

    lines.push('ABOUT THE COURSE');
    lines.push('');

    const aboutParagraphs = details.about.split('\n');

    aboutParagraphs.forEach((paragraph) => {
      if (!paragraph.trim()) {
        lines.push('');
        return;
      }

      const wrapped = wrapText(paragraph);

      wrapped.forEach((line) => {
        lines.push(line);
      });

      lines.push('');
    });

    lines.push('COURSE INFORMATION');
    lines.push('');
    lines.push(`Course: ${course.title}`);
    lines.push(
      `Price: Rs. ${offerPrice.toLocaleString('en-IN')}`
    );
    lines.push('');
    lines.push(
      'WeIntern - Learn, Build and Grow with Industry-Relevant Skills'
    );

    /*
     * PDF supports one A4 page.
     * If content becomes longer, create additional pages.
     */

    const pageWidth = 595;
    const pageHeight = 842;

    const leftMargin = 50;
    const topMargin = 790;

    const lineHeight = 17;

    const maxLinesPerPage = 42;

    const pages = [];

    for (
      let i = 0;
      i < lines.length;
      i += maxLinesPerPage
    ) {
      pages.push(
        lines.slice(i, i + maxLinesPerPage)
      );
    }

    if (pages.length === 0) {
      pages.push(['Course Curriculum']);
    }

    const objects = [];

    const catalogObject = 1;
    const pagesObject = 2;

    const pageObjectStart = 3;

    const fontObject =
      pageObjectStart + pages.length * 2;

    const pageObjectNumbers = [];
    const contentObjectNumbers = [];

    for (let i = 0; i < pages.length; i++) {
      pageObjectNumbers.push(
        pageObjectStart + i * 2
      );

      contentObjectNumbers.push(
        pageObjectStart + i * 2 + 1
      );
    }

    objects.push(
      `${catalogObject} 0 obj
<<
/Type /Catalog
/Pages ${pagesObject} 0 R
>>
endobj
`
    );

    const kids = pageObjectNumbers
      .map((number) => `${number} 0 R`)
      .join(' ');

    objects.push(
      `${pagesObject} 0 obj
<<
/Type /Pages
/Kids [${kids}]
/Count ${pages.length}
>>
endobj
`
    );

    pages.forEach((pageLines, pageIndex) => {
      const pageObjectNumber =
        pageObjectNumbers[pageIndex];

      const contentObjectNumber =
        contentObjectNumbers[pageIndex];

      let content = '';

      content += 'BT\n';

      content += '/F1 16 Tf\n';

      content += `${leftMargin} ${topMargin} Td\n`;

      pageLines.forEach((line, lineIndex) => {
        if (lineIndex === 0) {
          content += `(${escapePdfText(
            line
          )}) Tj\n`;

          content += '0 -28 Td\n';

          content += '/F1 11 Tf\n';

          return;
        }

        content += `(${escapePdfText(
          line
        )}) Tj\n`;

        content += `0 -${lineHeight} Td\n`;
      });

      content += 'ET';

      objects.push(
        `${pageObjectNumber} 0 obj
<<
/Type /Page
/Parent ${pagesObject} 0 R
/MediaBox [0 0 ${pageWidth} ${pageHeight}]
/Resources <<
  /Font <<
    /F1 ${fontObject} 0 R
  >>
>>
/Contents ${contentObjectNumber} 0 R
>>
endobj
`
      );

      objects.push(
        `${contentObjectNumber} 0 obj
<<
/Length ${content.length}
>>
stream
${content}
endstream
endobj
`
      );
    });

    objects.push(
      `${fontObject} 0 obj
<<
/Type /Font
/Subtype /Type1
/BaseFont /Helvetica
>>
endobj
`
    );

    let pdf = '%PDF-1.4\n';

    const offsets = [0];

    objects.forEach((object) => {
      offsets.push(pdf.length);
      pdf += object;
    });

    const xrefPosition = pdf.length;

    pdf += `xref\n`;
    pdf += `0 ${objects.length + 1}\n`;
    pdf += `0000000000 65535 f \n`;

    for (let i = 1; i < offsets.length; i++) {
      pdf += `${String(offsets[i]).padStart(
        10,
        '0'
      )} 00000 n \n`;
    }

    pdf += `trailer\n`;
    pdf += `<<
/Size ${objects.length + 1}
/Root ${catalogObject} 0 R
>>
`;

    pdf += `startxref\n`;
    pdf += `${xrefPosition}\n`;
    pdf += `%%EOF`;

    const blob = new Blob([pdf], {
      type: 'application/pdf',
    });

    const url = URL.createObjectURL(blob);

    const link = document.createElement('a');

    link.href = url;

    link.download =
      `${course.title
        .replace(/[^a-z0-9]/gi, '-')
        .toLowerCase()}-curriculum.pdf`;

    document.body.appendChild(link);

    link.click();

    document.body.removeChild(link);

    setTimeout(() => {
      URL.revokeObjectURL(url);
    }, 1000);
  };

  return (
    <div
      className="cd-overlay"
      onClick={(event) => {
        if (event.target === event.currentTarget) {
          onClose();
        }
      }}
    >
      <div className="cd-modal">

        {/* Header */}

        <div className="cd-header">

          <button
            type="button"
            className="cd-close"
            onClick={onClose}
            aria-label="Close course details"
          >
            ×
          </button>

          <span className="cd-badge-cert">
            CERTIFICATION COURSE
          </span>

          <h2 className="cd-title">
            {course.title}
          </h2>

          <p className="cd-tagline">
            {details.tagline}
          </p>

          <div className="cd-highlights">
            <div className="cd-highlight-item">
              <Icon icon="mdi:check-circle" className="cd-highlight-icon" />
              <span>100% Placement Assistance</span>
            </div>
            <div className="cd-highlight-item">
              <Icon icon="mdi:certificate-outline" className="cd-highlight-icon" />
              <span>Industry-Recognized Certificate</span>
            </div>
            <div className="cd-highlight-item">
              <Icon icon="mdi:account-group-outline" className="cd-highlight-icon" />
              <span>Live Interactive Classes</span>
            </div>
            <div className="cd-highlight-item">
              <Icon icon="mdi:briefcase-outline" className="cd-highlight-icon" />
              <span>Real-World Projects</span>
            </div>
          </div>

          <div className="cd-price-row">

            <span className="cd-original">
              ₹{originalPrice.toLocaleString('en-IN')}
            </span>

            <span className="cd-offer">
              ₹{offerPrice.toLocaleString('en-IN')}
            </span>

            <span className="cd-discount">
              {discount}% OFF
            </span>

          </div>

          <button
            type="button"
            className="cd-enroll-btn"
            onClick={onEnroll}
          >
            Enroll Now
          </button>

        </div>


        {/* Body */}

        <div className="cd-body">

          {/* About */}

          <section className="cd-section">

            <p className="cd-section-label">
              Overview
            </p>

            <h3 className="cd-section-title">
              About this course
            </h3>

            <p className="cd-about-text">
              {details.about}
            </p>

          </section>


          {/* Curriculum */}

          <section className="cd-section">

            <p className="cd-section-label">
              Curriculum
            </p>

            <div className="cd-curriculum-promo">

              <div className="cd-curriculum-content">

                <h3 className="cd-curriculum-heading">
                  Get the Full Course{' '}
                  <span>Curriculum</span>
                </h3>

                <p>
                  Want the detailed week-by-week breakdown?
                  <br />

                  Download the complete curriculum for{' '}
                  <strong>
                    {course.title}
                  </strong>{' '}
                  and see every topic covered.
                </p>

              </div>

              <button
                type="button"
                onClick={downloadCurriculum}
                className="cd-download-btn"
              >
                <Icon
                  icon="mdi:download"
                  width="18"
                  height="18"
                />

                Download Curriculum
              </button>

            </div>

          </section>


          {/* Demo */}

          <section className="cd-section">

            <p className="cd-section-label">
              Preview
            </p>

            <h3 className="cd-section-title">
              See It Live
            </h3>

            <p className="cd-section-desc">
              Want a walkthrough before you enroll?
              <br />

              Book a free live demo session with our team
              and get your questions about{' '}
              {course.title} answered directly.
            </p>

            <a
              href="https://wa.me/917414974582"
              target="_blank"
              rel="noreferrer"
              className="cd-demo-btn"
            >
              Book Demo
            </a>

          </section>


          {/* Mentor */}

          <section className="cd-section">

            <p className="cd-section-label">
              Meet your guide
            </p>

            <h3 className="cd-section-title">
              Your Mentor
            </h3>

            <div className="cd-mentor-card">

              <div className="cd-mentor-avatar">
                {details.mentor.name.charAt(0)}
              </div>

              <div className="cd-mentor-content">

                <h4 className="cd-mentor-name">
                  {details.mentor.name}
                </h4>

                <p className="cd-mentor-role">
                  {details.mentor.role}
                </p>

                <p className="cd-mentor-bio">
                  {details.mentor.bio}
                </p>

                <a
                  href={`mailto:${details.mentor.email}`}
                  className="cd-mentor-email"
                >
                  {details.mentor.email}
                </a>

              </div>

            </div>

          </section>


          {/* Testimonials */}

          <section className="cd-section">

            <p className="cd-section-label">
              Real feedback
            </p>

            <h3 className="cd-section-title">
              Student Testimonials
            </h3>

            <div className="cd-testimonials">

              {details.testimonials.map(
                (testimonial, index) => (
                  <div
                    key={`${testimonial.name}-${index}`}
                    className="cd-testimonial-card"
                  >

                    <div className="cd-testimonial-avatar">
                      {testimonial.name.charAt(0)}
                    </div>

                    <div>

                      <strong>
                        {testimonial.name}
                      </strong>

                      <p>
                        {testimonial.batch}
                      </p>

                    </div>

                  </div>
                )
              )}

            </div>

          </section>

        </div>

      </div>
    </div>
  );
};

export default CourseDetailModal;